import {ColorResult, SketchPicker} from 'react-color'
import {Box} from "@material-ui/core";
import {FC, useEffect, useRef, useState} from "react";
import styled from "styled-components/macro";
import {Popover} from "@mui/material";
import Button from "@mui/material/Button";

const Swatch = styled.div`
  padding: 5px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 0 0 1px rgba(0,0,0,.1);
  display: inline-block;
  cursor: pointer;
`

const Color = styled.div`
  width: 100%;
  height: calc(100% - 20px);
  margin: 10px;
  border-radius: 4px;
`

type PropsType = {
  color: string
  onChange: (result: ColorResult) => void
  ml?: number
  mr?: number
  defaultColor?: string
}

const ColorPicker: FC<PropsType> = ({
  color,
  onChange,
  mr = 0,
  ml = 0,
  defaultColor = 'rgb(18, 22, 25)'
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <Box ml={ml} mr={mr}>
      <Button
        aria-describedby={id}
        variant="contained"
        onClick={handleClick}
        style={{height: '100%', background: 'rgba(255, 255, 255, 0.1)', padding: 0}}
      >
        <Color style={{background: color ? color : defaultColor}}/>
      </Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <SketchPicker
          color={color}
          onChange={onChange}
        />
      </Popover>
    </Box>
  )
}

export default ColorPicker